const initialState = {
  isFetchingPreSelectedPeers: false,
  preSelectedPeers: {},
};

const selectPeersForReviewee = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_SELECTED_PEERS":
      return {
        ...state,
        preSelectedPeers: action.payload,
      };
    case "TOGGLE_IS_FETCHING_SELECTED_PEERS":
      return {
        ...state,
        isFetchingPreSelectedPeers: !state.isFetchingPreSelectedPeers,
      };
    default:
      return state;
  }
};

export default selectPeersForReviewee;
